import { StyleSheet } from 'aphrodite';
import { brandSecondary } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	button: {
		marginTop: 16,
	},
	container: {
		color: '#4A4A4A',
		position: 'relative',
	},
	inputField: {
		height: 200,
		resize: 'none',
	},
	message: {
		fontSize: 14,
		marginBottom: 16,
	},
	title: {
		color: brandSecondary,
		fontSize: 18,
		marginBottom: 16,
	},
});
